module.exports = __webpack_public_path__ + "img/mobile-menu-partner.604dd112.webp";